<template>
  <div class="productCenter">
    <div class="banner"><img :src="banner" /></div>
    <div class="productCenter-content">
      <div class="productCenter-content-left">
        <img :src="productTitle" @click="changeType(-1)" />
        <div v-for="(item, index) in productType" :key="index" @click="changeType(index)"
          :class="active == index ? 'active' : ''">
          <span>{{ item }}</span>
          <span class="arrow-right"></span>
        </div>
      </div>
      <div class="productCenter-content-right">
        <div class="title">产品中心<span v-if="subtitle"> > {{ subtitle }}</span></div>
        <img v-for="(item, index) in showImg" :key="index" :src="item" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'productCenter',
  data() {
    return {
      active: -1,
      banner: require("../../assets/img/productCenter/banner.png"),
      productTitle: require("../../assets/img/productCenter/productTitle.png"),
      productType: ['清洁服务工具车', '地面清洁工具', '玻璃清洁工具', '机械清洁车', '垃圾袋', '其他清洁配件'],
      showImg: [],
      subtitle: '',
      productTypeImg: [require("../../assets/img/productCenter/product1.png"), require("../../assets/img/productCenter/product2.png"), require("../../assets/img/productCenter/product3.png"), require("../../assets/img/productCenter/product4.png"), require("../../assets/img/productCenter/product5.png"), require("../../assets/img/productCenter/product6.png"), require("../../assets/img/productCenter/product7.png")],
      // 工具车
      toolCart: [require("../../assets/img/toolCart/01@2x.png"), require("../../assets/img/toolCart/02@2x.png"), require("../../assets/img/toolCart/03@2x.png"), require("../../assets/img/toolCart/04@2x.png"), require("../../assets/img/toolCart/05@2x.png"),
      require("../../assets/img/toolCart/06@2x.png"), require("../../assets/img/toolCart/07@2x.png"), require("../../assets/img/toolCart/08@2x.png"), require("../../assets/img/toolCart/09@2x.png"), require("../../assets/img/toolCart/10@2x.png"),
      require("../../assets/img/toolCart/11@2x.png"), require("../../assets/img/toolCart/12@2x.png"), require("../../assets/img/toolCart/13@2x.png"), require("../../assets/img/toolCart/14@2x.png"), require("../../assets/img/toolCart/15@2x.png")],
      // 地面清洁工具
      groundTool: [require("../../assets/img/groundTool/01@2x.png"), require("../../assets/img/groundTool/02@2x.png"), require("../../assets/img/groundTool/03@2x.png"), require("../../assets/img/groundTool/04@2x.png"), require("../../assets/img/groundTool/05@2x.png"),
      require("../../assets/img/groundTool/06@2x.png"), require("../../assets/img/groundTool/07@2x.png"), require("../../assets/img/groundTool/08@2x.png"), require("../../assets/img/groundTool/09@2x.png"), require("../../assets/img/groundTool/10@2x.png"),
      require("../../assets/img/groundTool/11@2x.png"), require("../../assets/img/groundTool/12@2x.png"), require("../../assets/img/groundTool/13@2x.png"), require("../../assets/img/groundTool/14@2x.png")],
      // 玻璃清洁工具
      glassTool: [require("../../assets/img/glassTool/01@2x.png"), require("../../assets/img/glassTool/02@2x.png"), require("../../assets/img/glassTool/03@2x.png"), require("../../assets/img/glassTool/04@2x.png"), require("../../assets/img/glassTool/05@2x.png"),
      require("../../assets/img/glassTool/06@2x.png"), require("../../assets/img/glassTool/07@2x.png"), require("../../assets/img/glassTool/08@2x.png"), require("../../assets/img/glassTool/09@2x.png"), require("../../assets/img/glassTool/10@2x.png"),
      require("../../assets/img/glassTool/11@2x.png"), require("../../assets/img/glassTool/12@2x.png"), require("../../assets/img/glassTool/13@2x.png"), require("../../assets/img/glassTool/14@2x.png"), require("../../assets/img/glassTool/15@2x.png"),
      require("../../assets/img/glassTool/15@2x.png"), require("../../assets/img/glassTool/15@2x.png"), require("../../assets/img/glassTool/15@2x.png")],
      // 机械清洁车
      cleaningTruck: [require("../../assets/img/cleaningTruck/01@2x.png"), require("../../assets/img/cleaningTruck/02@2x.png"), require("../../assets/img/cleaningTruck/03@2x.png"), require("../../assets/img/cleaningTruck/04@2x.png"), require("../../assets/img/cleaningTruck/05@2x.png"),
      require("../../assets/img/cleaningTruck/06@2x.png"), require("../../assets/img/cleaningTruck/07@2x.png"), require("../../assets/img/cleaningTruck/08@2x.png"), require("../../assets/img/cleaningTruck/09@2x.png"), require("../../assets/img/cleaningTruck/10@2x.png")],
      // 垃圾袋
      trashBag: [require("../../assets/img/trashBag/01@2x.png"), require("../../assets/img/trashBag/02@2x.png"), require("../../assets/img/trashBag/03@2x.png"), require("../../assets/img/trashBag/04@2x.png"), require("../../assets/img/trashBag/05@2x.png"),
      require("../../assets/img/trashBag/06@2x.png"),],
      // 清洁剂
      detergent: [require("../../assets/img/detergent/01@2x.png"), require("../../assets/img/detergent/02@2x.png"), require("../../assets/img/detergent/03@2x.png"), require("../../assets/img/detergent/04@2x.png"), require("../../assets/img/detergent/05@2x.png"),
      require("../../assets/img/detergent/06@2x.png"), require("../../assets/img/detergent/07@2x.png"), require("../../assets/img/detergent/08@2x.png"), require("../../assets/img/detergent/09@2x.png"), require("../../assets/img/detergent/10@2x.png"),
      require("../../assets/img/detergent/11@2x.png"), require("../../assets/img/detergent/12@2x.png"), require("../../assets/img/detergent/13@2x.png"), require("../../assets/img/detergent/14@2x.png"), require("../../assets/img/detergent/15@2x.png"),
      require("../../assets/img/detergent/16@2x.png"), require("../../assets/img/detergent/17@2x.png"), require("../../assets/img/detergent/18@2x.png"),
      require("../../assets/img/detergent/19@2x.png"), require("../../assets/img/detergent/20@2x.png"), require("../../assets/img/detergent/21@2x.png"), require("../../assets/img/detergent/22@2x.png"), require("../../assets/img/detergent/23@2x.png"),
      require("../../assets/img/detergent/24@2x.png"), require("../../assets/img/detergent/25@2x.png"), require("../../assets/img/detergent/26@2x.png"), require("../../assets/img/detergent/27@2x.png"),
      ],
      // 其他配件
      otherAccessories: [require("../../assets/img/otherAccessories/01@2x.png"), require("../../assets/img/otherAccessories/02@2x.png"), require("../../assets/img/otherAccessories/03@2x.png"), require("../../assets/img/otherAccessories/04@2x.png"), require("../../assets/img/otherAccessories/05@2x.png"),
      require("../../assets/img/otherAccessories/06@2x.png"), require("../../assets/img/otherAccessories/07@2x.png"), require("../../assets/img/otherAccessories/08@2x.png"), require("../../assets/img/otherAccessories/09@2x.png"), require("../../assets/img/otherAccessories/10@2x.png"),
      require("../../assets/img/otherAccessories/11@2x.png"), require("../../assets/img/otherAccessories/12@2x.png"), require("../../assets/img/otherAccessories/13@2x.png"), require("../../assets/img/otherAccessories/14@2x.png"), require("../../assets/img/otherAccessories/15@2x.png"),
      require("../../assets/img/otherAccessories/16@2x.png"), require("../../assets/img/otherAccessories/17@2x.png"), require("../../assets/img/otherAccessories/18@2x.png"),
      require("../../assets/img/otherAccessories/19@2x.png"), require("../../assets/img/otherAccessories/20@2x.png"), require("../../assets/img/otherAccessories/21@2x.png"), require("../../assets/img/otherAccessories/22@2x.png"), require("../../assets/img/otherAccessories/23@2x.png"),
      require("../../assets/img/otherAccessories/24@2x.png"), require("../../assets/img/otherAccessories/25@2x.png"), require("../../assets/img/otherAccessories/26@2x.png"), require("../../assets/img/otherAccessories/27@2x.png"),
      require("../../assets/img/otherAccessories/28@2x.png"),
      require("../../assets/img/otherAccessories/29@2x.png")],

    }
  },
  mounted() {
    this.showImg = [...this.productTypeImg]
  },
  methods: {
    changeType(idx) {
      this.active = idx
      if (idx == -1) {
        this.showImg = [...this.productTypeImg]
      } else {
        let arr = [this.toolCart, this.groundTool, this.glassTool, this.cleaningTruck, this.trashBag, this.detergent, this.otherAccessories]
        this.subtitle = this.productType[idx]
        this.showImg = arr[idx]
      }
    }
  }
}
</script>
<style lang="less" scoped>
.productCenter {
  background: #fff;
  padding-top: 80px;

  img {
    display: block;
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }


  .productCenter-content {
    padding: 45px 260px 105px;
    display: flex;
    box-sizing: border-box;
    background: #FAFBFF;

    .productCenter-content-left {
      width: 332px;
      flex-shrink: 0;

      div {
        line-height: 72px;
        height: 72px;
        font-size: 16px;
        padding: 0 12px;
        border: #DDDDDD solid;
        border-width: 0 1px 1px 1px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        .arrow-right {
          display: block;
          width: 8px;
          height: 8px;
          border: #DDDDDD solid;
          border-width: 2px 2px 0 0;
          transform: rotate(45deg);
        }
      }

      .active {
        color: #2797FF;
        font-weight: bold;
      }

      img {
        width: 100%;
      }
    }

    .productCenter-content-right {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .title {
        margin-left: 24px;
        width: 100%;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        border-bottom: 1px solid #DDDDDD;
        padding: 20px 0;
      }

      img {
        margin: 20px;
        width: 30%;
        cursor: pointer;
      }
    }
  }
}
</style>
